var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconThumbnail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 7H8.5C7.39543 7 6.5 7.89543 6.5 9V31C6.5 32.1046 7.39543 33 8.5 33H31.5C32.6046 33 33.5 32.1046 33.5 31V9C33.5 7.89543 32.6046 7 31.5 7Z",
    stroke: "#46B476",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 23.2027L15.7037 15L22.6622 23.4552L26.7584 20.0049L33.5 26",
    stroke: "#46B476",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 15C25.5 16.1039 24.6039 17 23.5 17C22.3961 17 21.5 16.1052 21.5 15C21.5 13.8948 22.3948 13 23.5 13C24.6052 13 25.5 13.8948 25.5 15Z",
    stroke: "#46B476",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconThumbnail);
export default __webpack_public_path__ + "static/media/icon_thumbnail.7f19408fac2d1f11216b5ace6b3464b6.svg";
export { ForwardRef as ReactComponent };